import {
  DocumentLink,
  PostTemplateRequestBody,
} from "@/models/document-link/DocumentLink";
import { crudService, CrudServiceType } from "./crudService";
import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";

export type DocumentLinkServiceType = CrudServiceType<DocumentLink> & {
  postTemplate: (requestBody: PostTemplateRequestBody) => RestResponse<string>;
  fetchByDocumentId: (documentId: string) => RestResponse<DocumentLink[]>;
};

const documentLinkService = (
  client: RestClient,
  path: string
): DocumentLinkServiceType => ({
  ...crudService<DocumentLink>(client, path),
  postTemplate: async (requestBody: PostTemplateRequestBody) =>
    await client.fetch(RequestMethod.POST, `${path}/template`, requestBody),
  fetchByDocumentId: async (documentId: string) =>
    await client.fetch<DocumentLink[]>(
      RequestMethod.GET,
      `${path}/by-document/${documentId}`
    ),
});

export default documentLinkService;
